import type { Person } from '@/types'

export const CURRENT_USER_SLUG = 'mahsa-karimi'

export const PEOPLE: Person[] = [
    {
        slug: 'mahsa-karimi',
        name: 'مهسا کریمی',
        role: 'کارشناس ارشد معماری نرم‌افزار',
        unit: 'architecture',
        expertise: ['طراحی API', 'معماری میکروسرویس', 'بانکداری باز', 'یکپارچه‌سازی سامانه‌ها'],
        joined: '1399/07/01',
        bio: 'در تیم معماری سامانه‌ها روی استانداردسازی رابط‌های برنامه‌نویسی و الگوهای یکپارچه‌سازی سامانه‌های بانکی کار می‌کند.',
        tone: 0
    },
    {
        slug: 'reza-ahmadi',
        name: 'رضا احمدی',
        role: 'مدیر فنی پروژه بانکداری شرکتی',
        unit: 'corporate-banking',
        expertise: ['مدیریت پروژه چابک', 'بانکداری شرکتی', 'مدیریت الزامات'],
        joined: '1396/03/15',
        bio: 'هدایت فنی پروژه‌های بانکداری شرکتی و هماهنگی میان تیم‌های توسعه و واحدهای کسب‌وکار را بر عهده دارد.',
        tone: 1
    },
    {
        slug: 'negar-salehi',
        name: 'نگار صالحی',
        role: 'کارشناس ارشد امنیت اطلاعات',
        unit: 'security',
        expertise: ['امنیت نرم‌افزار', 'DevSecOps', 'ارزیابی آسیب‌پذیری', 'انطباق با استانداردها'],
        joined: '1398/01/20',
        bio: 'روی تعریف کنترل‌های امنیتی چرخه توسعه و آماده‌سازی تیم‌ها برای ممیزی‌های امنیتی تمرکز دارد.',
        tone: 2
    },
    {
        slug: 'hamid-norouzi',
        name: 'حمید نوروزی',
        role: 'کارشناس ارشد زیرساخت و پایش',
        unit: 'infrastructure',
        expertise: ['پایش سرویس‌ها', 'تحلیل لاگ', 'شبکه', 'پایداری سامانه‌ها'],
        joined: '1395/09/10',
        bio: 'مسئول طراحی سامانه‌های پایش و هشداردهی و مالک حوزه دانش فنی و تخصصی در سامانه مدیریت دانش است.',
        tone: 3
    },
    {
        slug: 'amir-taheri',
        name: 'امیرحسین طاهری',
        role: 'راهبر فنی تیم سامانه‌های پرداخت',
        unit: 'payments',
        expertise: ['سوئیچ پرداخت', 'شاپرک و شتاب', 'بهینه‌سازی کارایی', 'عیب‌یابی سرویس‌ها'],
        joined: '1397/05/01',
        bio: 'تیم توسعه سرویس‌های پرداخت را هدایت می‌کند و تجربه گسترده‌ای در عیب‌یابی ارتباط با شبکه‌های پرداخت دارد.',
        tone: 0
    },
    {
        slug: 'zahra-ghasemi',
        name: 'زهرا قاسمی',
        role: 'کارشناس ارشد بهبود فرایند',
        unit: 'process-quality',
        expertise: ['مدل‌سازی فرایند', 'BPMN', 'ITIL', 'مستندسازی سازمانی'],
        joined: '1397/11/05',
        bio: 'مالک حوزه دانش فرایندی است و بر هم‌راستایی مستندات فرایندها با رویه‌های مصوب سازمان نظارت دارد.',
        tone: 2
    },
    {
        slug: 'mohammad-jafari',
        name: 'محمد جعفری',
        role: 'کارشناس آموزش فنی',
        unit: 'learning',
        expertise: ['طراحی آموزشی', 'آموزش ابزارها', 'جذب و ورود همکاران'],
        joined: '1400/02/12',
        bio: 'طراحی مسیرهای یادگیری و تولید محتوای آموزشی برای تیم‌های فنی را بر عهده دارد.',
        tone: 4
    },
    {
        slug: 'fatemeh-mousavi',
        name: 'فاطمه موسوی',
        role: 'تحلیلگر ارشد داده',
        unit: 'data-analytics',
        expertise: ['تحلیل تراکنش‌ها', 'هوش تجاری', 'گزارش‌های مدیریتی'],
        joined: '1398/08/18',
        bio: 'گزارش‌های تحلیلی روند تراکنش‌ها و شاخص‌های عملکرد خدمات پرداخت را برای مدیران تهیه می‌کند.',
        tone: 1
    },
    {
        slug: 'pouya-hosseini',
        name: 'پویا حسینی',
        role: 'مدیر پروژه نوسازی سامانه کارت',
        unit: 'card-systems',
        expertise: ['مهاجرت داده', 'سامانه‌های کارت', 'مدیریت ریسک پروژه'],
        joined: '1396/12/01',
        bio: 'پروژه نوسازی زیرساخت سامانه صدور و مدیریت کارت را از مرحله طراحی تا استقرار هدایت کرده است.',
        tone: 3
    },
    {
        slug: 'saeed-rostami',
        name: 'سعید رستمی',
        role: 'سرپرست تضمین کیفیت',
        unit: 'qa',
        expertise: ['خودکارسازی آزمون', 'آزمون API', 'بازبینی کد'],
        joined: '1397/02/25',
        bio: 'تیم تضمین کیفیت را سرپرستی می‌کند و مالک حوزه نوآوری و بهبود در سامانه مدیریت دانش است.',
        tone: 0
    },
    {
        slug: 'samira-nazari',
        name: 'سمیرا نظری',
        role: 'تحلیلگر ارشد سیستم',
        unit: 'lending',
        expertise: ['تحلیل سیستم', 'سامانه‌های تسهیلات', 'مستندسازی معماری'],
        joined: '1399/01/16',
        bio: 'تحلیل و مستندسازی سامانه یکپارچه تسهیلات و هماهنگی آن با سامانه‌های اعتبارسنجی را بر عهده دارد.',
        tone: 4
    },
    {
        slug: 'ali-sharifi',
        name: 'علی شریفی',
        role: 'راهبر فنی همراه‌بانک',
        unit: 'digital-banking',
        expertise: ['توسعه موبایل', 'انتشار تدریجی', 'تجربه کاربری خدمات دیجیتال'],
        joined: '1398/04/09',
        bio: 'تیم فنی اپلیکیشن همراه‌بانک را هدایت می‌کند و روی کیفیت انتشار نسخه‌ها تمرکز دارد.',
        tone: 2
    }
]

export const PERSON_BY_SLUG = Object.fromEntries(PEOPLE.map(person => [person.slug, person])) as Record<string, Person>

export const CURRENT_USER = PERSON_BY_SLUG[CURRENT_USER_SLUG]
